import React from "react";
import InvitePair from "../../../../components/InvitePair";
import PropTypes from "prop-types";
import PartnerGame from "../PartnerGame";
import PersonalAccount from "../../../../store/PersonalAccount";
import models from "../../../../types/models";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import "./style.scss";
export default observer(function UserGames({ startGame }) {
  UserGames.propTypes = {
    games: PropTypes.arrayOf(models.game),
    startGame: PropTypes.func.isRequired,
  };
  const { t } = useTranslation();

  return PersonalAccount.games.length
    ? PersonalAccount.games.map((game, idx) => {
        return !game.invitedUserId ? (
          <InvitePair
            key={game.id}
            // link может быть null: FK games.linkId обнуляется ON DELETE SET NULL
            link={game.link?.link}
            id={idx}
            game={game}
            className="pair-invite"
            title={t("personal_acc.invite_title")}
            startGame={startGame}
          />
        ) : (
          game.status !== "DELETED" && game.partner ? (
            <PartnerGame key={game.id} game={game} startGame={startGame} />
          ) : null
        );
      })
    : null;
});
